import { render, staticRenderFns } from "./BaseMenuItem.vue?vue&type=template&id=1d0c5334&scoped=true"
import script from "./BaseMenuItem.vue?vue&type=script&lang=js"
export * from "./BaseMenuItem.vue?vue&type=script&lang=js"
import style0 from "./BaseMenuItem.vue?vue&type=style&index=0&id=1d0c5334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0c5334",
  null
  
)

export default component.exports